import graphql from "babel-plugin-relay/macro";
import { useMemo } from "react";
import { useFragment } from "react-relay";

import { useGetCourseOptions_CourseBucket$key } from "./__generated__/useGetCourseOptions_CourseBucket.graphql";

export type courseOption = {
  id: string;
  name: string;
  description: string;
  maxDurationMins: number;
  startSlotId: string;
};

export const useGetCourseOptions = ({
  courseBucketRef,
  additionalCourseOptionsToAdd,
}: {
  courseBucketRef: useGetCourseOptions_CourseBucket$key | null;
  additionalCourseOptionsToAdd?: courseOption[];
}) => {
  const courseBucket = useFragment(
    useGetCourseOptionsFragmentString,
    courseBucketRef
  );

  // Get the maximum duration from valid customer booking selections
  const courseOptions = useMemo(() => {
    if (!courseBucket) return [];

    const validSelections = courseBucket.slotDurations || [];

    // Map the valid selections to course options
    return validSelections.map((selection) => ({
      id: selection?.startSlot?.course?.id || "",
      name: selection?.startSlot?.course?.name || "",
      description: selection?.startSlot?.course?.description || "",
      maxDurationMins: selection?.maxDurationMins || 0,
      startSlotId: selection?.startSlot?.id || "",
    }));
  }, [courseBucket]);

  return [...courseOptions, ...(additionalCourseOptionsToAdd || [])];
};

const useGetCourseOptionsFragmentString = graphql`
  fragment useGetCourseOptions_CourseBucket on CourseBucket {
    slotDurations(startsAt: $startTime, agendaId: $agendaId) {
      startSlot {
        id
        course {
          name
          description
          id
        }
      }
      maxDurationMins
    }
  }
`;
